import api from "./api";

const analyticsService = {
  getStudents: (params) => api.get("/analytics/students", { params }),
  getTeachers: (params) => api.get("/analytics/teachers", { params }),
  getAttendance: (params) => api.get("/analytics/attendance", { params }),
  getAssignments: (params) => api.get("/analytics/assignments", { params }),
  getDashboardStats: (params) => api.get("/analytics/dashboard-stats", { params }),
  getTeacherLectureStats: (params) => api.get("/analytics/teacher-lecture-stats", { params }),
  exportTeacherLectureStats: (params) => api.get("/analytics/teacher-lecture-stats/export", { params }),
  getDepartments: (params) => api.get("/analytics/departments", { params }),
  getInstitutes: (params) => api.get("/analytics/institutes", { params }),
};

export default analyticsService;
